import {
  authClient
} from '@api/auth'
const ROLE_ADMIN = 'ROLE_ADMIN'
const initialState = () => ({
  email: undefined,
  roles: [],
  userName: undefined,
  promises: {
    detailsFetchPromise: undefined
    // loginNotifyPostPromise: undefined,
    // cashInflowNotifyPostPromise: undefined,
    // walletsFetchPromise: undefined,
    // walletAddPromise: undefined,
    // walletEditPromise: undefined,
    // walletDeletePromise: undefined,
    // phoneUpdatePromise: undefined,
    // telegramUpdatePromise: undefined,
    // twoFactorSetupPromise: undefined,
    // twoFactorUpdatePromise: undefined,
    // recoveryCodesFetchPromise: undefined,
    // recoveryCodesGeneratePromise: undefined,
    // showPhonePromise: undefined,
    // showTelegramPromise: undefined,
    // userSettingsUpdatePromise: undefined
  }
  // kycStatus: {},
  // bitrentFreezeStatus: undefined
})

export default {
  namespaced: true,
  state: initialState(),
  getters: {
    user: state => {
      const {
        email,
        userName
      } = state
      return {
        email,
        userName
      }
    },
    authenticated: _ => authClient.authenticated,
    isAdmin: state => state.roles.some(x => x === ROLE_ADMIN),
    detailsFetching: state => state.promises.detailsFetchPromise !== undefined
  },
  mutations: {
    reset (state) {
      const initial = initialState()
      Object.keys(initial).forEach(k => {
        state[k] = initial[k]
      })
    },
    details (state, {
      userName,
      email,
      roles
    }) {
      state.userName = userName
      state.email = email
      state.roles = roles
    },
    detailsFetchPromise (state, promise) {
      state.promises.detailsFetchPromise = promise
    }

  },
  actions: {
    fetchDetails (ctx) {
      if (ctx.getters.detailsFetching) return
      const promise = authClient.getDetails()
        .then(resp => {
          ctx.commit('detailsFetchPromise', undefined)
          ctx.commit('details', resp.data)
          return resp
        })
        .catch(error => {
          ctx.commit('detailsFetchPromise', undefined)
          throw error
        })
      ctx.commit('detailsFetchPromise', promise)
      return promise
    }

  }
}



// WEBPACK FOOTER //
// ./src/state/account-module.js